import { Menu, MenuItem, Grid, ListItem as ListItemMUI, List, ListItemAvatar } from '@material-ui/core';

import styled from 'styled-components';

import { getColorPrimary } from '../../../../libs';

export const MenuCart = styled(Menu)`
  hr {
    height: 2px;
    margin: 5px 0;
    width: 100%;
  }

  .MuiMenu-list {
    padding: 8px !important;
    max-width: 350px !important;
    min-width: 200px !important;
    min-height: 50px !important;
    position: relative !important;
  }
`;

export const GridPrices = styled(Grid)`
  padding: 5px !important;
`;

export const ListItemAvatarStyled = styled(ListItemAvatar)`
  min-width: 40px !important;
  margin-right: 5px !important;
`;

export const ListCart = styled(List)`
  max-height: 185px !important;
  overflow-y: auto !important;
  padding-top: 0 !important;
  border-radius: 3px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #00000040 !important;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c9c9c9;
    border-radius: 10px;
  }
`;

export const ListItemCart = styled(ListItemMUI)`
  padding: 5px !important;
  height: 60px !important;
  overflow: hidden !important;

  &:hover {
    background: #00000010;
  }
`;

export const CartText = styled.p`
  font-size: ${({ fontsize }) => fontsize || '13px'} !important;
  color: ${({ color }) => color || '#555555'} !important;
  width: ${({ width }) => width || 'unset'} !important;
  text-align: ${({ textalign }) => textalign || 'left'} !important;
  white-space: normal !important;
  padding: ${({ padding }) => padding || '0'};
  font-weight: ${({ weight }) => weight};
  margin: 0;
  span {
    margin-left: 7px;
    font-weight: normal;
    color: #555555;
  }
`;

export const CartTextName = styled(CartText)`
  flex: 1 !important;
  overflow: hidden;
  max-height: 52px !important;
`;

export const MenuItemStyled = styled(MenuItem)`
  margin: 2.5px;
`;

export const MenuItemExit = styled(MenuItem)`
  margin: 2.5px;
  &:hover {
    background: #d32f2f20 !important;
  }

  * {
    color: red !important;
  }
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const LinkLogo = styled.a`
  display: flex;
  align-items: center;
`;

export const GridButton = styled(Grid)`
  padding: 10px 5px 0 5px !important;
`;

export const ListItem = styled.li`
  padding: 0px;
  display: flex;
  justify-content: center;
`;
export const ListItemPrices = styled.li`
  margin: 10px 0 0 0;
  position: relative;
  border-radius: 3px;
  padding: 10px 0;
`;

export const Empty = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  svg {
    margin-right: 8px;
  }
`;

export const Title = styled.li`
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${getColorPrimary};
  font-weight: bold;
  padding: 8px;

  svg {
    margin-right: 8px;
    font-size: 25px;
  }
`;
